// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__3rpOd","gfeWrapper":"CalendarEvent_gfeWrapper__3_fDl"};